import React, { useEffect, useState, useContext } from "react";
import {
  Form,
  Input,
  Button,
  message,
  DatePicker,
  Select,
  Typography,
  Divider,
} from "antd";
import { Context } from "../context/store";
import ACTIONS from "../context/actions";
import { logoutUser } from "../helpers/authHelper";
import { baseAPIUrl } from "../constants/urlConstants";
import { LotCreator } from "./LotCreator";
import { SourceMedAdder } from "./SourceMedAdder";

const { Option } = Select;
const { Title } = Typography;

export const SourceMedCreator = (props) => {
  const [form] = Form.useForm();
  const [state, dispatch] = useContext(Context);
  const [submitting, setSubmitting] = useState(false);
  const [products, setProducts] = useState([]);
  const [sourceMeds, setSourceMeds] = useState([]);
  const [filteredSourceMeds, setFilteredSourceMeds] = useState([]);

  //get products and source meds in order to suggest them
  useEffect(() => {
    //when loading ensure page is set

    //get the info on sourcemeds
    fetch(baseAPIUrl + "sourcemeds?status=complete", {
      headers: { user_key: state.key },
    })
      .then((res) => {
        //check if need to login again
        if (res.status === 401) {
          message.info("Please Login Again!");
          logoutUser();
          dispatch({ type: ACTIONS.CLEAR_USER_DETAILS });
          return false;
        }
        return res.json();
      })
      .then(
        (results) => {
          setSourceMeds(results);
          setFilteredSourceMeds(results);
        },
        (error) => {
          console.log(error);
        },
      );
    //get products
    fetch(baseAPIUrl + "sourceproducts", {
      headers: { user_key: state.key },
    })
      .then((res) => {
        //check if need to login again
        if (res.status === 401) {
          message.info("Please Login Again!");
          logoutUser();
          dispatch({ type: ACTIONS.CLEAR_USER_DETAILS });
          return false;
        }
        return res.json();
      })
      .then(
        (results) => {
          setProducts(results);
        },
        (error) => {
          console.log(error);
        },
      );

    dispatch({
      type: ACTIONS.SET_CURRENT_PAGE,
      payload: { page: "createSourceMed" },
    });
  }, []);

  const onProductChange = (value) => {
    const selectedProduct = products.find((product) => {
      return product.id === value;
    });

    console.log(selectedProduct);
    form.setFieldsValue({
      dominance: selectedProduct.dominance,
      material: selectedProduct.material,
    });
  };

  const onSourceMedChange = (value) => {
    const selectedMed = sourceMeds.find((med) => {
      return med.id === value;
    });

    console.log(selectedMed);
    form.setFieldsValue({
      medID: value,
      sourceMedPotencyTHC: selectedMed.potencythc,
      sourceMedPotencyCBD: selectedMed.potencycbd,
    });
  };

  //handles sending data from form to DB
  const onSubmitSourceMed = (values) => {
    console.log("submitting source med");
    console.log(values);
    setSubmitting(true);
    fetch(baseAPIUrl + "sourcemeds", {
      method: "POST",
      body: JSON.stringify({
        ...values,
      }),
      headers: {
        "Content-Type": "application/json",
        user_key: state.key,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then(
        (results) => {
          setSubmitting(false);
          if (results.success) {
            form.resetFields();
            message.success(results.message);
          } else {
            message.error(results.message);
          }
        },
        (error) => {
          setSubmitting(false);
          message.error("Failed to create the source med");
          console.log(error);
        },
      );
  };

  return (
    <div className="creator-content">
      <Form
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 16,
        }}
        layout="horizontal"
        name="source_med_creator"
        className="source_med-creator"
        initialValues={{ remember: true }}
        scrollToFirstError
        form={form}
        onFinish={onSubmitSourceMed}
      >
        <Title level={2}>Create A Source Med Ticket</Title>
        <Divider />
        <Form.Item
          label="Source Material Product"
          name="product"
          rules={[
            {
              message: "Source requires a name!",
              required: true,
            },
          ]}
        >
          <Select
            showSearch
            placeholder="Product To Make/Process"
            optionFilterProp="children"
            onChange={onProductChange}
          >
            {products.map((product, i) => (
              <Option value={product.id} key={i}>{`${product.name}`}</Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="Homogenization Date"
          name="manufacturing_date"
          rules={[
            {
              message: "Must enter a Homogenization Date",
              required: true,
            },
          ]}
        >
          <DatePicker format="MM/DD/YYYY" />
        </Form.Item>
        <Form.Item
          label="New Batch ID"
          name="batch_id"
          rules={[
            {
              message: "A new batchid must be given to a source med!",
              required: true,
            },
          ]}
        >
          <Input maxLength={100} placeholder="Batch ID" />
        </Form.Item>
        <SourceMedAdder hideWIPs={true}></SourceMedAdder>
        <LotCreator batchID={form.getFieldValue("batch_id")} />
        <Form.Item
          label="Material"
          name="material"
          rules={[
            {
              message: "Must select a type of material!",
              required: true,
            },
          ]}
        >
          <Input disabled placeholder="Material"></Input>
        </Form.Item>
        <Form.Item
          label="Dominance"
          name="dominance"
          rules={[
            {
              message: "Must select a dominance!",
              required: true,
            },
          ]}
        >
          <Input disabled placeholder="Dominance"></Input>
        </Form.Item>
        <Form.Item
          label="Notes"
          name="comments"
          rules={[
            {
              required: false,
            },
          ]}
        >
          <Input size="large"></Input>
        </Form.Item>
        <Form.Item label=" " colon={false}>
          <Button
            type="primary"
            htmlType="submit"
            className="submit-ticket-button"
            loading={submitting}
          >
            Submit Ticket
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
